import { faPeopleGroup } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { DomainTypeGq } from '../../../../../graphql/projects/models/DomainTypeGq';
import { ProjectGq } from '../../../../../graphql/projects/models/ProjectGq';
import DataTableToolbarButton from '../../../../voxel/DataTableToolbar/DataTableToolbarButton';
import { KeywordTableState } from '../logic/useKeywordTableState';

export interface DomainsButtonProps {
  project: ProjectGq;
  tableState: KeywordTableState;
}

export const DomainsButton: React.FC<DomainsButtonProps> = ({ tableState, project }) => {
  const handleToggleRanks = () => {
    tableState.setTableUIState((prev) => ({
      ...prev,
      showDomainsPanel: !prev.showDomainsPanel,
      showTagPanel: false,
    }));

    if (!tableState.tableUIState.showDomainsPanel) {
      tableState.columnPickerBag.showProjectDomain(
        project.domains?.find((d) => d.type === DomainTypeGq.PROJECT)?.id
      );
    }
  };
  return (
    <DataTableToolbarButton
      tooltip="Toggle competitors panel"
      label="Competitors"
      iconProp={faPeopleGroup}
      effect={
        !!project.serpTriggered && !project?.domains?.some((d) => d.type === DomainTypeGq.PROJECT)
          ? 'success'
          : undefined
      }
      onClick={handleToggleRanks}
      toggle={tableState.tableUIState.showDomainsPanel}
    />
  );
};

export default DomainsButton;
